import { usePermission } from './usePermission';
import { ACTION_FLAG } from './permission-actions';

/**
 * Can — declarative permission gate (SA-1592 Phase A0).
 *
 * Renders `children` only when the resolved `menu` grants `action`; otherwise
 * renders `fallback`. Supports `children` as a render function
 * `(isAllowed) => ReactNode` for call sites that want to disable rather than
 * hide. Renders no wrapper element (DOM parity) — fail-closed on an unknown
 * action or missing flag.
 *
 * @param {object} props
 * @param {string} props.action - an ACTION enum value.
 * @param {string} props.menu - a MENU key or pathname understood by usePermission.
 * @param {React.ReactNode} [props.fallback=null] - rendered when not allowed.
 * @param {React.ReactNode | ((isAllowed: boolean) => React.ReactNode)} props.children
 */
const Can = ({ action, menu, fallback = null, children }) => {
  const perms = usePermission(menu);
  const flag = ACTION_FLAG[action];
  const isAllowed = Boolean(flag) && perms[flag] === true;

  if (typeof children === 'function') return children(isAllowed);

  if (!isAllowed) return fallback;
  return children;
};

export default Can;
